//#region src/engine/modules/settings/scrollRange.ts
var unsigned = (value) => value + 0;
function contentScrollRange(near, far, viewportLength, zoomLevel) {
	const farEdgeAtStart = -far * zoomLevel;
	const nearEdgeAtEnd = viewportLength - near * zoomLevel;
	return {
		min: unsigned(Math.min(farEdgeAtStart, nearEdgeAtEnd)),
		max: unsigned(Math.max(farEdgeAtStart, nearEdgeAtEnd))
	};
}
function openingOrigin(origin, near, far, viewportLength, zoomLevel) {
	const { min, max } = contentScrollRange(near, far, viewportLength, zoomLevel);
	if (min < origin && origin < max) return origin;
	const drawn = Math.min(viewportLength, (far - near) * zoomLevel);
	return unsigned(Math.min(Math.max(origin, min + drawn), max - drawn));
}
//#endregion
export { contentScrollRange, openingOrigin };
